import ActiveModel from "./ActiveModel";
import SubclassModel from "./SubclassModel";
import { Details } from "../pages/main/query/topic/products/product-detail";

export type ProductModel = {
    idProduct?: number,
    idBody: number,
    idTypeUse: number,
    description: string,
    active: ActiveModel[],
    subclass?: SubclassModel[],
    productName: string,
    mechanismAction: string,
    pH: string,
    minimumDosage: string,
    maxDosage: string,
    source: string,
    incompatibility?: string,
    pregnant: boolean,
    vegan: boolean,
    organic: boolean,
    period: string,
    daytime?: number|null,
    nighttime?: number|null,
    percentage?: string,
    favorite?: number,
    classes: string|null,
    annotation?: string,
    showConcentration?: boolean,
    //oral
    name?: string,
    mechanism?: string,
    max?: number,
    min?: number,
    unity?: string,
    id?: number,
}

export type ProductWriteModel = Omit<ProductModel, "pH" | "classes" | "showConcentration"> & {
    phProduct: string,
}

export const productModelToDetails = (product: ProductModel) => {
    const id = product.idProduct? product.idProduct : product.id
    const name = product.productName? product.productName : product.name
    const mechanism = product.mechanismAction? product.mechanismAction : product.mechanism

    return {
        name: name,
        mechanism: mechanism,
        description: product.description,
        ph: product.pH,
        incompatibility: product.incompatibility? product.incompatibility : '',
        minimum: product.minimumDosage,
        maximum: product.maxDosage,
        source: product.source,
        daytime: product.daytime,
        nighttime: product.nighttime,
        vegan: product.vegan,
        organic: product.organic,
        pregnant: product.pregnant,
        classes: product.classes,
        id: id,
        favorite: !!product.favorite,
        annotation: product.annotation,
        showConcentration: product.showConcentration,
        unity: product.unity,
        min: product.min,
        max: product.max,
        period: product.period,
        percentage: product.percentage? product.percentage : '',
    } as Details
}
